import type { GitConnection, GitRepo } from "@/services/git/types";
import { StatCard } from "./shared";

export function OverviewPane({
  connection, selectedRepo,
}: {
  connection: GitConnection;
  selectedRepo: GitRepo;
}) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 p-8">
      <div className="grid w-full max-w-sm grid-cols-2 gap-3">
        <StatCard label="Repository" value={selectedRepo.name} mono />
        <StatCard label="Default branch" value={selectedRepo.default_branch} mono />
        <StatCard label="Owner" value={selectedRepo.owner_login} mono />
        <StatCard label="Connected as" value={connection.provider_login ?? ""} mono />
      </div>
      <p className="text-center text-xs text-muted-foreground">
        Select a commit or pull request from the left panel to inspect changes.
      </p>
    </div>
  );
}
